import { baseApi } from "../api/baseAPI";

interface getUnreadNotificationsCountResponse {
  unreadCount: number;
}

export interface getInAppNotificationsListResponse {
  created: Date;
  read: boolean;
  route: string;
  text: string;
  _id: string;
}

const inAppNotificationsApiWithTags = baseApi.enhanceEndpoints({
  addTagTypes: [
    "GET_UNREAD_INAPP_NOTIFICATIONS_COUNT",
    "IN_APP_NOTIFICATIONS_LIST",
  ],
});

export const inAppNotificationsApi =
  inAppNotificationsApiWithTags.injectEndpoints({
    endpoints: (builder) => ({
      getUnreadInAppNotificationsCount: builder.query<
        getUnreadNotificationsCountResponse,
        void
      >({
        query: () => ({
          url: "/v1/inAppNotification/unreadCount",
          method: "GET",
        }),
        providesTags: ["GET_UNREAD_INAPP_NOTIFICATIONS_COUNT"],
      }),
      getInAppNotificationsList: builder.query<
        getInAppNotificationsListResponse[],
        number
      >({
        query: (page: number) => ({
          url: `/v1/inAppNotification/list?page=${page}`,
          method: "GET",
        }),
        providesTags: ["IN_APP_NOTIFICATIONS_LIST"],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetUnreadInAppNotificationsCountQuery,
  useGetInAppNotificationsListQuery,
} = inAppNotificationsApi;
